import React from 'react';
import { Car, BatteryCharging, Truck, Bus, Bike, Ship } from 'lucide-react';
import { VEHICLE_TYPES } from '../mock';

const iconMap = {
  car: Car,
  'battery-charging': BatteryCharging,
  truck: Truck,
  bus: Bus,
  bike: Bike,
  ship: Ship
};

export const VehicleTypesSection = () => {
  return (
    <section className="py-28 lg:py-36 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-green/8 text-brand-green-dark rounded-full text-sm font-semibold mb-6 border border-brand-green/15">
            Fahrzeugarten
          </div>
          <h2 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-gray-900 mb-6 tracking-tight">
            Gutachten für alle Fahrzeugarten
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-normal">
            Von PKW bis Boot – wir begutachten sämtliche Fahrzeugtypen professionell
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-7 gap-6">
          {VEHICLE_TYPES.map((vehicle, index) => {
            const Icon = iconMap[vehicle.icon];
            return (
              <div key={index} className="flex flex-col items-center text-center p-8 bg-white border border-gray-100 rounded-3xl hover:border-brand-green/30 hover:shadow-2xl transition-all duration-500 card-hover">
                <div className="w-16 h-16 bg-brand-green/10 rounded-2xl flex items-center justify-center mb-5 border border-brand-green/15">
                  <Icon className="w-8 h-8 text-brand-green" />
                </div>
                <span className="text-[15px] font-bold text-gray-900">{vehicle.name}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};